<template>
  <a-card class="style1">
    <h2 class="pb-2">Upgrade Membership</h2>
    <h3>
      <span class="label label-success">GET PRICING</span>
      <img src="https://truelifeorg.s3.amazonaws.com/images/downarrow.png" style="height: 40px; width: auto" />
      To see pricing and join, select your church’s average attendance
    </h3>
    <br />
    <div class role="group" aria-label="...">
      <button
        v-for="plan in plans"
        :key="plan.key"
        type="button"
        :class="`btn btn-info btn-lg ${plan.key === planSelected.key ? 'selected' : ''}`"
        style="color: white; margin: 0 3px; margin-bottom: 3px"
        @click="selectPlan(plan)"
      >
        {{ plan.text }}
      </button>

      <button type="button" class="btn btn-info btn-lg" style="color: white; margin: 0 3px; margin-bottom: 3px" @click="callnumber">2,500+</button>
      <button type="button" class="btn btn-info btn-lg" style="color: white; margin: 0 3px; margin-bottom: 3px" @click="makeOffer">Or Make Your Offer</button>
    </div>
    <div class="quotes-section" style="text-align: center; padding-top: 2rem">
      <span style="font-size: 17px">"Brothers, my heart's desire and prayer to God for them is that they may be saved." Romans 10:1</span>
    </div>
    <a-row :gutter="20" class="upgrade-membership">
      <a-col :xs="24" :md="12">
        <div class="monthly_pricing">
          <div class="monthly_header">
            <h4>
              Monthly Plan
              <sub>(12 Payments Required)</sub>
            </h4>
            <h5>
              <span v-if="isEmpty(planSelected)" id="message_display">$ - SELECT ABOVE</span>
              <span v-else id="monthtext" class="smalltext" v-text="`$${separateNumber(planSelected.pricemonth / 100)}/MO`" />
            </h5>
            <br />
            <center v-if="!isEmpty(planSelected)">
              <div id="joinmonthbutton" class="find_church_btn" style="float: none">
                <a style="border-radius: 10px; color: white" href="javascript:void(0)" @click="joinPlan('month')">Join Monthly Plan</a>
              </div>
            </center>
            <br />
          </div>
          <p id="message_cards"></p>
          <pricing-monthly-feature :message_cards="isEmpty(planSelected) ? '---' : separateNumber(planSelected.cardsnumber)" />
        </div>
      </a-col>
      <a-col :xs="24" :md="12">
        <div class="monthly_pricing">
          <div class="monthly_header">
            <h4>
              Yearly Plan
              <sub>(save 16%)</sub>
            </h4>
            <h5>
              <span v-if="isEmpty(planSelected)" id="message_display">$ - SELECT ABOVE</span>
              <span v-else id="monthtext" class="smalltext" v-text="`$${separateNumber(planSelected.priceyear / 100)}/YR`" />
            </h5>
            <br />
            <center v-if="!isEmpty(planSelected)">
              <div id="joinyearbutton" class="find_church_btn" style="float: none">
                <a style="border-radius: 10px; color: white" href="javascript:void(0)" @click="joinPlan('year')">Join Yearly Plan</a>
              </div>
            </center>
            <br />
          </div>
          <p id="message_cards2"></p>
          <pricing-monthly-feature :message_cards="isEmpty(planSelected) ? '---' : separateNumber(planSelected.cardsnumber)" />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <!-- Above and Beyond Guarantees -->
      <a-col :span="24">
        <div class="monthly_pricing" style="padding: 10px">
          <img src="https://truelifeorg.s3.amazonaws.com/images/Satisfaction+Guaranteed+Vector+Badge+Gold.png" class="pricing-satis" style="width: 300px; float: left" />
          <h3 class="pricing-guarantee-title">Above and Beyond Guarantees:</h3>
          <p>If there is EVER a TrueLife.org video or article the church disagrees with, you get a full refund.</p>
          <p>If your leadership says no after watching the introduction video and before we design your invitation cards and print them, you get a full refund.</p>
          <p>You have 30 days with the cards to follow our strategy. If you are unhappy with the result, we will give you a full refund.</p>
        </div>
      </a-col>
    </a-row>

    <a-modal title="Upgrade Membership" centered v-model="isVisibleModal" :closable="false" class="shipping-address-form" width="800">
      <template slot="footer">
        <a-button key="back" @click="isVisibleModal = false"> Cancel </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="upgradeMembership"> Save </a-button>
      </template>
      <a-form :form="form" :layout="'vertical'" id="billing-setup">
        <a-row>
          <a-col :xs="{ span: 24 }" :md="{ span: 11, offset: 1 }">
            <a-form-item label="Card Number" required>
              <a-input v-model="cardNumber" data-recurly="number" size="large" :max-length="19" pattern="[0-9]">
                <a-icon slot="addonBefore" type="credit-card" />
                <fa-icon v-if="cardType" slot="addonAfter" :icon="['fab', cardType]" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :md="{ span: 5, offset: 1 }">
            <a-form-item label="Expiration">
              <a-input-group compact size="large" style="min-width: 140px">
                <a-input v-decorator="['mm', { rules: [{ required: true }] }]" data-recurly="month" placeholder="MM" style="width: 90px" :max-length="2">
                  <a-icon slot="addonBefore" type="calendar" />
                </a-input>
                <a-input v-decorator="['yy', { rules: [{ required: true }] }]" data-recurly="year" placeholder="YY" style="width: 44px" :max-length="2" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 5 }" :md="{ span: 5, offset: 1 }">
            <a-form-item label="CVV">
              <a-input v-decorator="['cvv', { rules: [{ required: true, message: 'CVV is required!' }] }]" data-recurly="cvv" placeholder="CVV" size="large" :max-length="4" style="min-width: 140px">
                <a-icon slot="addonBefore" type="lock" />
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item label="First Name">
              <a-input
                v-decorator="[
                  'firstname',
                  {
                    rules: [{ required: true, message: 'First Name is required!' }],
                  },
                ]"
                data-recurly="first_name"
                placeholder="First Name of Cardholder"
                size="large"
              >
                <a-icon slot="addonBefore" type="user" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 11, offset: 1 }">
            <a-form-item label="Last Name">
              <a-input
                v-decorator="[
                  'lastname',
                  {
                    rules: [{ required: true, message: 'Last Name is required!' }],
                  },
                ]"
                data-recurly="last_name"
                placeholder="Last Name of Cardholder"
                size="large"
              >
                <a-icon slot="addonBefore" type="user" />
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item>
          <span class="text-left" style="opacity: 0.9">* For company cards, split the company name between first and last name fields.</span>
        </a-form-item>
        <a-row>
          <a-col :xs="24" :md="{ span: 16, offset: 1 }">
            <a-form-item label="Address">
              <a-input v-decorator="['address1', { rules: [{ required: true, message: 'Address1 is required!' }] }]" data-recurly="address1" size="large" />
            </a-form-item>

            <a-form-item style="display: none" label="Address 2 (optional)">
              <a-input v-decorator="['address2']" data-recurly="address2" size="large" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="{ span: 9, offset: 1 }">
            <a-form-item label="City">
              <a-input v-decorator="['city', { rules: [{ required: true, message: 'City is required!' }] }]" data-recurly="city" size="large" />
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 6, offset: 1 }">
            <a-form-item label="State">
              <a-input v-decorator="['state', { rules: [{ required: true, message: 'State is required!' }] }]" data-recurly="state" size="large" />
            </a-form-item>
          </a-col>
          <a-col :md="{ span: 6, offset: 1 }">
            <a-form-item label="Zip Code">
              <a-input
                v-decorator="[
                  'zipcode',
                  {
                    rules: [{ required: true, message: 'Zip Code is required!' }],
                  },
                ]"
                data-recurly="postal_code"
                size="large"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="{ span: 24 }" class="d-flex align-items-center sign-pad-container">
            <a-col :xs="24" :md="12">
              <p style="max-width: 340px">
                By submitting payment you agree to the
                <a href="https://www.truelife.org/pages/privacy-policy">Privacy Policy</a>
                and
                <a href="https://www.truelife.org/pages/terms-of-use">Terms of Use</a>, and you agree to to speak with a representative to cancel your account to give us an opportunity to help your
                church stay with us.
              </p>
            </a-col>
            <a-col :xs="24" :md="12">
              <h3>Sign to upgrade membership</h3>
              <signature-pad ref="signature" name="signature" />
            </a-col>
          </a-col>
        </a-row>
        <input type="hidden" data-recurly="country" value="US" />
        <input type="hidden" data-recurly="token" name="billing_token" id="recurlyCode" />
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import { isEmpty, isString, isNumber, replace } from 'lodash';
import initRecurly from '@/services/Recurly';
import UserService from '@/services/UserService';
import PricingMonthlyFeature from '@/components/PricingMonthlyFeature';
import SignaturePad from '@/components/SignaturePad';
export default {
  name: 'UpgradeMembershipPage',
  components: {
    PricingMonthlyFeature,
    SignaturePad,
  },
  data() {
    return {
      connections: [],
      searching: '',
      isVisibleModal: false,
      error: '',
      isLoading: true,
      cardNumber: '',
      userData: [],
      plans: [
        {
          priceyear: 44900,
          cardsnumber: 3000,
          yearlyplans: '449yearly',
          pricemonth: 4400,
          monthlyplans: '44monthly',
          key: '0_49',
          text: '0 - 49',
        },
        {
          priceyear: 54900,
          cardsnumber: 3000,
          yearlyplans: '549yearly',
          pricemonth: 5400,
          monthlyplans: '54monthly',
          key: '50_99',
          text: '50 - 99',
        },
        {
          priceyear: 69900,
          cardsnumber: 5000,
          yearlyplans: '699yearly',
          pricemonth: 6900,
          monthlyplans: '69monthly',
          key: '100_149',
          text: '100 - 149',
        },
        {
          priceyear: 84900,
          cardsnumber: 10000,
          yearlyplans: '849yearly',
          pricemonth: 8400,
          monthlyplans: '84monthly',
          key: '150_399',
          text: '150 - 399',
        },
        {
          priceyear: 119900,
          cardsnumber: 20000,
          yearlyplans: '1199yearly',
          pricemonth: 11900,
          monthlyplans: '119monthly',
          key: '400_749',
          text: '400 - 749',
        },
        {
          priceyear: 169900,
          cardsnumber: 40000,
          yearlyplans: '1699yearly',
          pricemonth: 12900,
          monthlyplans: '129monthly',
          key: '750_1499',
          text: '750 - 1,499',
        },
        {
          priceyear: 219900,
          cardsnumber: 80000,
          yearlyplans: '2199yearly',
          pricemonth: 21900,
          monthlyplans: '219monthly',
          key: '1500_2500',
          text: '1,500 - 2,500',
        },
      ],
      planSelected: {},
    };
  },
  async mounted() {
    const plan = sessionStorage.getItem('plan');
    if (plan) {
      this.planSelected = JSON.parse(plan);
    }
    await initRecurly();
  },
  created() {
    this.form = this.$form.createForm(this, { name: 'upgradeMembership' });
  },
  computed: {
    isDesktop() {
      return typeof window !== 'undefined' && window.innerWidth >= 768;
    },
    cardType() {
      const number = this.cardNumber.replace(/\s/g, '');
      // https://fontawesome.com/v4/icons/#payment
      const cardIcons = ['amex', 'mastercard', 'dinners-club', 'discover', 'jcb', 'visa'];

      // https://stackoverflow.com/questions/72768/how-do-you-detect-credit-card-type-based-on-number
      const re = {
        electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
        maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
        dankort: /^(5019)\d+$/,
        interpayment: /^(636)\d+$/,
        unionpay: /^(62|88)\d+$/,
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mastercard: /^5[1-5][0-9]{14}$/,
        amex: /^3[47][0-9]{13}$/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      };

      for (const key in re) {
        if (re[key].test(number)) {
          return cardIcons.includes(key) ? `cc-${key}` : 'credit-card';
        }
      }

      return '';
    },
  },
  watch: {
    cardNumber() {
      if (!this.cardNumber) {
        return '';
      }

      this.cardNumber = this.cardNumber
        .replace(/\s/gi, '')
        .match(/.{1,4}/g)
        .join(' ');
    },
  },
  methods: {
    isEmpty,
    joinPlan(type) {
      this.planSelected = { ...this.planSelected, plan_code: this.planSelected[`${type}lyplans`] };
      this.isVisibleModal = true;
    },
    selectPlan(plan) {
      this.planSelected = plan;
    },
    callnumber() {
      alert('Please Call (800) 749-0570 For Pricing');
    },
    makeOffer() {
      location.href = 'https://form.jotform.com/210537589312053';
    },
    separateNumber(d, s) {
      if (!isString(d) && !isNumber(d)) {
        return 0;
      }
      if (!isString(s)) {
        s = ',';
      }
      d = replace(d.toString(), s);
      while (/(\d+)(\d{3})/.test(d.toString())) {
        d = d.toString().replace(/(\d+)(\d{3})/, '$1' + s + '$2');
      }
      return d;
    },
    async upgradeMembership() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const { isEmpty } = this.$refs.signature.submit();
          if (isEmpty) {
            this.$notification['error']({
              message: 'Please signin before upgrade membership!',
            });
            return false;
          }
          try {
            await this.checkoutRecurly();
          } catch (error) {
            let errorDescription = '';
            if (error.fields.includes('number')) {
              errorDescription = 'The card number is worng';
            } else if (error.fields.includes('cvv')) {
              errorDescription = 'The cvv is worng';
            } else {
              errorDescription = 'The expiration is worng';
            }
            this.$notification['error']({
              message: 'Invalid card!',
              description: errorDescription,
            });
          } finally {
            this.isLoading = false;
          }
          var billing_token = document.getElementById('recurlyCode').value;

          try {
            this.isLoading = true;
            if (billing_token) {
              await UserService.doUpgradeMembership({
                billing_token: billing_token,
                plan: this.planSelected.plan_code,
              });
              this.$notification['success']({
                message: 'Upgrade successful.',
                description: `Credit Card Saved`,
              });
              this.$router.push({ path: '/upgrade-successfull' });
            }
          } catch (error) {
            this.$notification['error']({
              message: error.data.message,
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billing-setup'), err => {
          if (!isEmpty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
.btn.btn-info.btn-lg.selected {
  background: #6aaa2c;
  border-color: #6aaa2c;
}

.monthly_pricing {
  border: 1px solid #ddd;
  border-radius: 6px;
  width: 100%;
  float: left;
  font-family: 'proxima-nova', sans-serif;
  font-style: normal;
  font-weight: 400;
  box-shadow: 0 3px 11px 0 rgba(238, 238, 238, 0.4);
  margin: 15px 0;
  .find_church_btn {
    margin-top: 12px;
    min-width: 230px;
    a {
      padding: 17px 45px;
      letter-spacing: 1px;
      display: initial;
      background-color: #7cbc3f;
      &:hover {
        box-shadow: 1px 1px 5px grey;
      }
    }
  }
}

.monthly_header {
  height: 207px;
  border-bottom: 2px solid #dddddd;
  display: table;
  text-align: center;
  width: 100%;
  padding-top: 48px;
  h4 {
    font-size: 26px;
    margin: 0 0 20px 0;
    sub {
      font-size: 17px;
      bottom: 0;
      margin-left: 2px;
    }
  }
  h5 {
    font-size: 54px;
    margin: 0;
    sub {
      font-size: 26px;
      bottom: -0.1em;
      margin-left: 2px;
    }
  }
}

.team_section {
  background-color: #fafafa;
  border-top: 1px solid #e6e6e6;
  margin-top: 136px;
  padding: 130px 0 152px 0;
  text-align: center;
  h6 {
    font-size: 20px;
    margin: 9px 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 4px;
    a {
      color: #333333;
      &:hover {
        color: #3a96a7;
      }
    }
  }
  small {
    font-size: 13px;
    color: #999999;
    display: block;
    text-transform: uppercase;
    margin-bottom: 11px;
  }
  p {
    font-size: 17px;
    color: #666666;
    line-height: 26px;
  }
}

.man_img {
  a {
    width: 155px;
    height: 155px;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 100px;
    border: 4px solid #dedede;
    &:hover {
      border-color: #7cbc3f;
    }
    img {
      border-radius: 100px;
    }
  }
}

// New updates:
.pricing-head {
  margin-left: 1%;
  margin-right: 1%;
  margin-bottom: 40px;
  @media (max-width: 568px) {
    margin-top: 22px;
    margin-bottom: 22px;
    h3 {
      font-size: 18px;
    }
    .btn-lg {
      font-size: 14px;
    }
  }
}
.pricing-satis {
  width: 300px;
  float: left;
  @media (max-width: 568px) {
    width: auto;
    padding: 0 10%;
    float: none;
  }
}
.pricing-guarantee-title {
  margin-top: 30px;
  @media (max-width: 568px) {
    margin-top: 0px;
    font-size: 20px;
  }
}
.sign-pad-container {
  flex-direction: row;
}
@media only screen and (max-device-width: 596px) {
  .sign-pad-container {
    flex-direction: column;
  }
}
</style>
